// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ATVIv","col":"styles_col__3r-q6"};